import { render } from "./CategoriesView.vue?vue&type=template&id=4bdfb398&scoped=true"
const script = {}

import "./CategoriesView.vue?vue&type=style&index=0&id=4bdfb398&lang=scss&scoped=true"

import exportComponent from "/Users/rboss/repos/TRENZ/Kunden/KaRa/Mockup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdfb398"]])

export default __exports__